import { NetIncomeType } from '@nemuru-eng/js-api-client';
import { z } from 'zod';

import { GetTextIdTranslationType } from '@/components/shared/hooks/useTranslation';
import { requiredEnum, requiredNumber, requiredString } from '@/utils/zodUtils';

export const NetIncomeFormSchema = (t: GetTextIdTranslationType) =>
  z.object({
    monthlyNetIncome: requiredString(t),
    numberOfYearlyPayments: requiredNumber(t),
    netIncomeType: requiredEnum(NetIncomeType, t),
  });

export type NetIncomeFormType = z.infer<ReturnType<typeof NetIncomeFormSchema>>;
